
export const pageTextConfig = {
    orderSuccessTitle: 'Order Successful',
    orderSuccessMessage: 'Order Successful with transaction ID',
    estimatedDelivery: 'Estimated Delivery:',
    queryMessage: 'In case you have any queries, feel free to reach out to us via:',
    checkOrdersButton: 'Check My Orders',
    continueShoppingButton: 'Continue Shopping'
  };
  
export default pageTextConfig;
